module.exports = __webpack_public_path__ + "images/album_90.f1913cc0d8238004e6511873e5ff504a.png";